import { ALL_PREBILLS, FILTER_PREBILLS, SEARCH_PREBILLS, CLEAR_FILTER_PREBILLS, ALERT_SESSION} from "../action-types.js";
import axios from "axios"
import {url, urlFront} from "../../App.js";


export const getAllPreBills = () => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'get',
                url: `${url}/preBills`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            };
            const response = await axios(config)
            dispatch({
                type: ALL_PREBILLS,
                payload: response.data.allElements
            })
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}
export const getFilterPreBills = (filtros) => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'post',
                url: `${url}/preBills/filter`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
                data: filtros
            };
            const response = await axios(config)
            if (response.status === 200) {
                dispatch({
                    type: FILTER_PREBILLS,
                    payload: response.data.preBills
                })
            }
            else if (response.status === 204) {
                dispatch({
                    type: FILTER_PREBILLS,
                    payload: ["Sin resultados"]
                })
            }
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;

            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  

            return errorResponse;    
        } 
    }
}
export const getSearchPreBills = (partialId) => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'get',
                url: `${url}/preBills/search/${partialId}`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            };
            const response = await axios(config)
            if (response.status === 200) {
                dispatch({
                    type: SEARCH_PREBILLS,
                    payload: response.data.preBills
                })
            }
            else if (response.status === 204) {
                dispatch({
                    type: SEARCH_PREBILLS,
                    payload: ["Sin resultados"]
                })
            }
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}

export const clearFilterPreBills = () => {
    return {
      type: CLEAR_FILTER_PREBILLS,
    };
  };